import React, { Component } from "react";

export default class Create extends Component {
  render() {
    return <div />;
  }
}
